import React from 'react'
import Cart_one_head from '../../components/mobile_view_comp/cart_one/cart_one_head'
import Mob_order_comp from '../../components/mobile_view_comp/mob_order_comp/mob_order_comp'

export default function Mob_order() {
  return (
    <>
      <div style={{width:'90%' , margin:'auto' ,marginTop:'65px' , marginBottom:'30px'}}>
          <Cart_one_head link='/profile' head='Order' />
          <Mob_order_comp />
      </div>
    </>
  )
}